import { TFunction } from 'react-i18next';
import type { ColumnData } from 'ui/tableHeader/constants';
import { DATE_FORMAT_FULL_WITH_HOURS_MINS, displayDate } from 'utils/date';
import { formatAsPercent } from 'utils/numberHelpers';
import {
  CampaignContributionsCSVData,
  CampaignContributionsResultsData,
  CampaignContributionTableHeader,
} from '../types';

const align = 'center';

export const getTableColumns = (t: TFunction): ColumnData[] => [
  {
    align,
    name: t('labels.campaignContributions.tableHeader.campaign'),
    value: CampaignContributionTableHeader.CAMPAIGN,
    sortable: true,
  },
  {
    align,
    name: t('labels.campaignContributions.tableHeader.dateLaunched'),
    value: CampaignContributionTableHeader.START_AT,
    sortable: true,
  },
  {
    align,
    name: t('labels.campaignContributions.tableHeader.status'),
    value: CampaignContributionTableHeader.STATUS,
    sortable: true,
  },
  {
    align,
    name: t('labels.campaignContributions.tableHeader.totalSent'),
    value: CampaignContributionTableHeader.SENDS,
    sortable: false,
  },
  {
    align,
    name: t('labels.campaignContributions.tableHeader.deliveryRate'),
    value: CampaignContributionTableHeader.DELIVERED,
    sortable: false,
  },
  {
    align,
    name: t('labels.campaignContributions.tableHeader.totalGoalContributions'),
    value: CampaignContributionTableHeader.CONTRIBUTIONS,
    sortable: false,
  },
  {
    align,
    name: t('labels.campaignContributions.tableHeader.uniqueGoalConversions'),
    value: CampaignContributionTableHeader.UNIQUE_CONTRIBUTIONS,
    sortable: false,
  },
  {
    align,
    name: t('labels.campaignContributions.tableHeader.channel'),
    value: CampaignContributionTableHeader.MESSAGE_MEDIUM,
    sortable: true,
  },
];

export const processCSVData = (
  data: CampaignContributionsResultsData[],
): CampaignContributionsCSVData[] => {
  const { origin } = window.location;
  return data.map<CampaignContributionsCSVData>(({ id, ...row }) => ({
    ...row,
    startedAt: displayDate(row.startedAt, DATE_FORMAT_FULL_WITH_HOURS_MINS),
    delivered: formatAsPercent(row.delivered),
    link: `${origin}/campaigns/review?campaignId=${id}`,
  }));
};

export const getCSVHeader = (t: TFunction) => [
  {
    key: CampaignContributionTableHeader.CAMPAIGN,
    label: t('labels.campaignContributions.tableHeader.campaign'),
  },
  {
    key: CampaignContributionTableHeader.START_AT,
    label: t('labels.campaignContributions.tableHeader.dateLaunched'),
  },
  {
    key: CampaignContributionTableHeader.STATUS,
    label: t('labels.campaignContributions.tableHeader.status'),
  },
  {
    key: CampaignContributionTableHeader.SENDS,
    label: t('labels.campaignContributions.tableHeader.totalSent'),
  },
  {
    key: CampaignContributionTableHeader.DELIVERED,
    label: t('labels.campaignContributions.tableHeader.deliveryRate'),
  },
  {
    key: CampaignContributionTableHeader.CONTRIBUTIONS,
    label: t('labels.campaignContributions.tableHeader.totalGoalContributions'),
  },
  {
    key: CampaignContributionTableHeader.UNIQUE_CONTRIBUTIONS,
    label: t('labels.campaignContributions.tableHeader.uniqueGoalConversions'),
  },
  {
    key: CampaignContributionTableHeader.MESSAGE_MEDIUM,
    label: t('labels.campaignContributions.tableHeader.channel'),
  },
  {
    key: 'link',
    label: t('labels.campaignContributions.tableHeader.link'),
  },
];
